import { COOKIE_DIALOG_LOCALSTORAGE, ICookieDialogLocalStorage } from '../types';
import { getCookieDialogLocalStorageInitial } from '../../types';

export const getCookieDialogLocalStorage = (
): ICookieDialogLocalStorage => {
    const data = localStorage.getItem(COOKIE_DIALOG_LOCALSTORAGE);
    const cookieDialogLocalStorage = data? JSON.parse(data): getCookieDialogLocalStorageInitial();
    return cookieDialogLocalStorage;
}
